import commonModule from '@/store/common/index'
import homeModule from '@/store/home/index'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pageShow: '',
    settingMapShow: false,
    mediaJsUrl: '',
    mapLoaded: 'false',
    userBehaviors: '',
    selectTId: '',
    ReceiverInfoObj: {},
    GetKernelStateObj: {},
    SettingObj: {
      CurrentSetting: {
        Name: 'Internal_Live'
      },
      ModeList: []
    },
    packList: [],
    onlinePackList: [],
    isFristInitWebrtc: true,
    showConfigT: true,
    showBg: true,
    showFeatureControl: true,
    webrtcUrl: 'http://10.12.23.232:9001',
    dashboardObj: {
      cpu: {},
      disks: {},
      memory: {},
      swap: {},
      sysinfo: {},
      user: {}
    },
    psdashVersion: '',
    clientId: '7b375a08-8177-4ec6-ada5-587979a1693c',
    showFeatureObj: {
      gridEncoder: false,
      transcriber: false,
      featureControl: false,
      visionTag: false,
      showVisionTag: true,
      IPStreamOut: false,
      isCoreSetting: true
    },
    interputObj: {
      userObj: true
    },
    channelNumber: 2,
    isFilePreview: false,
    currentSelectTab: 0,
    selectClipStartTime: 0,
    selectClipEndTime: 0,
    progressTid: '',
    selectSourceId: '',
    selectSourceName: '',
    selectSourceStatus: '',
    selectSourcePlatform: '',
    selectSourcePlatformType: '',
    selectSourceType: '',
    selectSourceLivePeerId: '',
    selectLastRId: '',
    selectCurrentRId: '',
    hasTranscriberFeature: false,
    websocket: {
      rInfoWebsocket: null,
      pageRequest: null,
      pageRWebsocket: null,
      pageAnyWheresockets: null,
      pageRPSSockets: null
    },
    baseUrl: {},
    baseUserInfo: {},
    testDataUrl: '/ccp/tvucc-rws/receiver/command',
    selectRId: '',
    selectRStatus: 1,
    selectRIp: '',
    selectRPort: '',
    voipInfo: { status: 0, peerId: '' },
    // 用来做兼容的
    currentRVersion: null,
    isSMPTE: false,
    allMySourceData: [],
    drawDownSource: null,
    receiverRList: [],
    changingR: false,
    messageNum: 0,
    isRcIframe: false,
    rpsSwitchInfo: {
      enable: 0,
      switchAIndex: 0,
      switchVIndex: 0,
      mainPid: ''
    },
    isRpsDue2: false,
    checkedGloabelSettings: false,
    activeTabPeerId: '',
    socketRPSList: {},
    rpsTakeMap: {}, // { [channelPeerId]: { sourceId, sourceName, rId, starting } } —— Take All 用
    rpsBitrateMaxMap: {}, // { [peerId小写]: MaximumValue } —— 单路 R 通过 OperationType=301 查到的 Bitrate 最大值，Global 取其中 min
    realRPSInfo: {},
    RPSSocketInfo: {
      ReceiverInfoObj: {},
      GetKernelStateObj: {},
      getAdapter: {},
      SettingObj: {}
    },
    AudiocontextObj: null,
    featureFlag: {
      shareTransmission: false,
      liveOnHoldFlag: false,
      showThumbnails: true,
      startTransmission: true,
      stopTransmission: true,
      aleartMessage: true,
      gridDescriptionConfirm: false,
      onlineNotify: true,
      offlineNotify: true,
      lowBatteryNotify: true,
      lowBatteryAutoClear: false,
      lowBatteryPlaySound: true,
      errorNotify: true,
      userDeviceBatteryInfo: null
    },
    deviceBattery: null,
    ipPortMappingInfo: {}
  },
  mutations: {
    websocket (state, data) {
      state.websocket = data
    },
    SET_USER_BEHAVIORS (state, data) {
      state.userBehaviors = data
    },
    SET_MESSAGE_NUM (state, data) {
      state.messageNum = data
    },
    SET_DEVICE_BATTERY (state, data) {
      state.deviceBattery = data
    }
  },
  /*
   * mutations,
   * actions,
   */
  modules: {
    common: commonModule,
    home: homeModule
  }
})
